import { gql } from '@apollo/client'

export const GET_AUDIENCE_INTEREST_ELIGIBLE = gql`
  query GetAudienceInterestEligible {
    user {
      id
      guildActions {
        audienceInterestFilmEligible
      }
    }
    userAudienceInterestFilmCount
  }
`

export const GET_AUDIENCE_INTEREST_FILM = gql`
  query GetAudienceInterestFilm {
    userAudienceInterestFilm {
      id
      filmId
      title
      description
      url
      duration
      purchasedAt
      latestWatchPosition
      type {
        content
        interest
      }
      audience
      ageGroups
      message
      ticketCode
      ticketAmount
    }
  }
`

export const CREATE_AUDIENCE_INTEREST_CHECKOUT = gql`
  mutation CreateAudienceInterestCheckout($input: AudienceInterestCheckoutInput!) {
    createAudienceInterestCheckout(input: $input) {
      id
      sessionId
      clientSecret
      amountTotal
      message
    }
  }
`

export const UPSERT_AUDIENCE_INTEREST_WATCH = gql`
  mutation UpsertAudienceInterestWatch($input: AudienceInterestFilmViewInput!) {
    createAudienceInterestFilmView(input: $input) {
      id
    }
  }
`

export const UPDATE_AUDIENCE_INTEREST_USER = gql`
  mutation UpdateAudienceInterestUser($input: AudienceInterestUserInput!) {
    updateAudienceInterestUser(input: $input) {
      id
    }
  }
`

export const UPDATE_AUDIENCE_INTEREST_TICKETS = gql`
  mutation UpdateAudienceInterestTickets($input: AudienceInterestTicketCountInput!) {
    updateAudienceInterestTicketCount(input: $input) {
      id
      count
      message
    }
  }
`
